import styled from 'styled-components'

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.8em;
  text-align: center;

  button {
    margin-top: 1.8em;
  }
`